import {satGlobals} from "../../../../../sat/helper/sat-globals";
import {projectHelper} from "../../../../../../lib-sat/misc/project-helper";

export default {
    props: {},
    data() {
        return {};
    },
    created: function () {},
    mounted: function () {},

    methods: {},
    computed: {
        isRegisteredUser() {
            return this.user?.isRegistered();
        },
        isFreeUser() {
            if (this.user === null) {
                return false;
            }
            return this.user.isPremium() === false;
        },
        isPremiumUser() {
            if (this.user === null) {
                return false;
            }
            return this.user.isPremium();
        },
        isProAndAboveUser() {
            if (this.user === null) {
                return false;
            }
            return this.user.isPro() === true || this.user.isUltimate() === true;
        },
    },
};
